import { Badge } from "@chakra-ui/react"
import { FaBell, FaEye, FaCheck } from "react-icons/fa6"

export type AlertStatusType = "new" | "acknowledged" | "attended" | "completed"

interface AlertStatusBadgeProps {
  status: AlertStatusType
}

export const alertStatusConfig = {
  new: {
    label: "New",
    backgroundColor: "#FED7D7", // Red/Orange
    textColor: "red.800",
    icon: FaBell,
  },
  acknowledged: {
    label: "Acknowledged",
    backgroundColor: "#BEE3F8", // Blue
    textColor: "blue.800",
    icon: FaEye,
  },
  attended: {
    label: "Attended",
    backgroundColor: "#E9D8FD", // Purple
    textColor: "purple.800",
    icon: FaEye,
  },
  completed: {
    label: "Resolved",
    backgroundColor: "#C6F6D5", // Green
    textColor: "green.800",
    icon: FaCheck,
  },
  ok: {
    label: "OK",
    backgroundColor: "#C6F6D5", // Green
    textColor: "green.800",
    icon: FaCheck,
  }
}

export function AlertStatusBadge({ status }: AlertStatusBadgeProps) {
  const config = alertStatusConfig[status]
  const Icon = config.icon

  return (
    <Badge
      backgroundColor={config.backgroundColor}
      color={config.textColor}
      variant="subtle"
      display="inline-flex"
      alignItems="center"
      gap={1}
    >
      <Icon style={{ width: "12px", height: "12px" }} />
      {config.label}
    </Badge>
  )
}

export default AlertStatusBadge